(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimseal-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /**
     * SwimSeal Reviews Carousel controller.
     * Handles arrow-button scrolling and visibility toggling.
     */
    class SwimSealReviewsCarousel {
      /**
       * @param {HTMLElement} wrapper - The .swimseal-reviews__carousel-wrapper element
       */
      constructor(wrapper) {
        this.carousel = wrapper.querySelector('.swimseal-reviews__carousel');
        this.prevBtn = wrapper.querySelector('.swimseal-reviews__arrow--prev');
        this.nextBtn = wrapper.querySelector('.swimseal-reviews__arrow--next');

        if (!this.carousel || !this.prevBtn || !this.nextBtn) return;

        this._init();
      }

      _init() {
        this.prevBtn.addEventListener('click', () => this._scroll('prev'));
        this.nextBtn.addEventListener('click', () => this._scroll('next'));
        this.carousel.addEventListener('scroll', () => this._updateArrows(), { passive: true });

        // Initial state
        this._updateArrows();
      }

      _getCardWidth() {
        const firstCard = this.carousel.querySelector('.swimseal-reviews__card');
        if (!firstCard) return 380;
        const gap = parseInt(getComputedStyle(this.carousel).gap) || 24;
        return firstCard.offsetWidth + gap;
      }

      _scroll(direction) {
        const distance = this._getCardWidth();
        this.carousel.scrollBy({
          left: direction === 'next' ? distance : -distance,
          behavior: 'smooth'
        });
      }

      _updateArrows() {
        const { scrollLeft, scrollWidth, clientWidth } = this.carousel;
        const atStart = scrollLeft <= 4;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 4;

        if (atStart) {
          this.prevBtn.setAttribute('hidden', '');
        } else {
          this.prevBtn.removeAttribute('hidden');
        }

        if (atEnd) {
          this.nextBtn.setAttribute('hidden', '');
        } else {
          this.nextBtn.removeAttribute('hidden');
        }
      }
    }

    // Init all carousels on the page
    document.querySelectorAll('.swimseal-reviews__carousel-wrapper').forEach((wrapper) => {
      new SwimSealReviewsCarousel(wrapper);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimseal-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /**
     * Parse a stat number string into { value, suffix, decimals }.
     * "12K+" → { value: 12, suffix: "K+", decimals: 0 }
     * "4.8"  → { value: 4.8, suffix: "",  decimals: 1 }
     * "97%"  → { value: 97,  suffix: "%",  decimals: 0 }
     */
    function parseStatNumber(text) {
      const match = text.match(/^([\d.]+)(.*)$/);
      if (!match) return null;

      const raw = match[1];
      const suffix = match[2] || '';
      const value = parseFloat(raw);
      const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;

      return { value, suffix, decimals };
    }

    /**
     * Ease-out cubic: t in [0,1] → position in [0,1].
     * @param {number} t
     * @returns {number}
     */
    function easeOut(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    /**
     * Animate a single stat element's counter.
     * @param {HTMLElement} el
     */
    function animateStat(el) {
      const numberEl = el.querySelector('.swimseal-stats__number');
      if (!numberEl) return;

      const raw = el.dataset.number || numberEl.textContent;
      const parsed = parseStatNumber(raw.trim());
      if (!parsed) return;

      const { value: target, suffix, decimals } = parsed;
      const duration = 2000;
      const startTime = performance.now();

      function tick(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const current = easeOut(progress) * target;
        const display = decimals > 0 ? current.toFixed(decimals) : Math.floor(current).toString();

        numberEl.textContent = display + suffix;

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          numberEl.textContent = target.toFixed(decimals) + suffix;
        }
      }

      requestAnimationFrame(tick);
    }

    function initStatsObserver() {
      const grids = document.querySelectorAll('.swimseal-stats__grid');

      if (!grids.length) return;

      // Respect prefers-reduced-motion
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            const items = entry.target.querySelectorAll('.swimseal-stats__item');
            for (const item of items) {
              if (reducedMotion) {
                // Just ensure the original value is shown correctly
                const numberEl = item.querySelector('.swimseal-stats__number');
                if (numberEl) numberEl.textContent = item.dataset.number || numberEl.textContent;
              } else {
                animateStat(item);
              }
            }

            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.3 }
      );

      for (const grid of grids) {
        observer.observe(grid);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStatsObserver);
    } else {
      initStatsObserver();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
